import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Field, Form } from 'react-final-form';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import renderCheckBoxField from '@/shared/components/form/CheckBox';
import { Button, Input, Alert } from 'reactstrap';
import KeyIcon from 'mdi-react/KeyIcon';
import { useAuth } from '../../../contexts/AuthContext';

const LogInForm = ({ onSubmit, loading, error }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { signInWithGoogle } = useAuth();

  const handleGoogleSignIn = async () => {
    await signInWithGoogle();
  };

  return (
    <Form onSubmit={() => onSubmit(email, password)}>
      {({ handleSubmit }) => (
        <form className="form" onSubmit={handleSubmit}>
          {error && (
            <Alert color="danger" className="mb-3">
              {error}
            </Alert>
          )}
          <div className="form__form-group">
            <span className="form__form-group-label">Email</span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <AccountOutlineIcon />
              </div>
              <Input
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                type="text"
                placeholder="Email"
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Password</span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <KeyIcon />
              </div>
              <Input
                name="password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Password"
              />
              <div className="account__forgot-password">
                <NavLink to="/reset_password">Forgot a password?</NavLink>
              </div>
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="remember_me"
                component={renderCheckBoxField}
                label="Remember me"
                type="checkbox"
              />
            </div>
          </div>
          <Button 
            className="btn btn-primary account__btn account__btn--small" 
            type="submit"
            disabled={loading}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </Button>
          <Button 
            className="btn btn-outline-primary account__btn account__btn--small" 
            onClick={handleGoogleSignIn}
            type="button"
            disabled={loading}
          >
            Sign In with Google
          </Button>
          <NavLink to="/signup" className="btn btn-outline-secondary account__btn account__btn--small">
            Create Account
          </NavLink>
        </form>
        )}
    </Form>
  );
};

LogInForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

LogInForm.defaultProps = {
  loading: false,
  error: null,
};

export default LogInForm;
